import { render, staticRenderFns } from "./Bienvenida.vue?vue&type=template&id=b022be12&scoped=true&"
import script from "./Bienvenida.vue?vue&type=script&lang=js&"
export * from "./Bienvenida.vue?vue&type=script&lang=js&"
import style0 from "./Bienvenida.vue?vue&type=style&index=0&id=b022be12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b022be12",
  null
  
)

export default component.exports